var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import ReactDOM from "react-dom/client";
import Widget from "./widget";
import "./styles/tailwind.css";
import "./styles/theme.css";
import configService from "./services/configService";
function loadScripts() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    });
}
function renderWidget(containerId, config) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1, defaultContainerId, targetId, container, shadowRoot, mountPoint, style;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadScripts()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, configService.initialize(true)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('Failed to initialize widget config:', error_1);
                    return [3 /*break*/, 5];
                case 5:
                    defaultContainerId = 'quicksmart-widget-container';
                    targetId = containerId || defaultContainerId;
                    container = document.getElementById(targetId);
                    // If container doesn't exist, create it
                    if (!container) {
                        container = document.createElement('div');
                        container.id = targetId;
                        document.body.appendChild(container);
                    }
                    if (!container.shadowRoot) {
                        shadowRoot = container.attachShadow({ mode: 'open' });
                    }
                    else {
                        shadowRoot = container.shadowRoot;
                    }
                    mountPoint = shadowRoot.getElementById('widget-root');
                    if (!mountPoint) {
                        mountPoint = document.createElement('div');
                        mountPoint.id = 'widget-root';
                        shadowRoot.appendChild(mountPoint);
                    }
                    style = document.createElement('style');
                    fetch('https://dqzwm4r7fngk2.cloudfront.net/widget.css')
                        .then(function (res) { return res.text(); })
                        .then(function (css) {
                        style.textContent = css;
                        shadowRoot.appendChild(style);
                        // Render your widget inside the shadow root after CSS is loaded
                        ReactDOM.createRoot(mountPoint).render(React.createElement(Widget, { config: config }));
                    });
                    return [2 /*return*/];
            }
        });
    });
}
window.renderWidget = renderWidget;
